import rankedArticleConfigs from "../rankedArticleConfigs.json";

const slug = "25-lowest-phosphorus-foods-without-prescription";

const lowestPhosphorusNoPrescription = {
  slug,
  title: "25 Lowest Phosphorus Foods without veterinary prescription",
  createdDate: "2026-04-09",
  updatedDate: null,
  author: "The Picky Kitty",
  imageKey: "low_phopshorus_dry.png",
  coverImageAlt: "Low phosphorus food comparison illustration",
  summary:
    "Discover 25 low phosphorus cat foods (no prescription required), sorted from lowest to highest on a dry matter basis.",
  category: "Top",
  articleType: "ranked_products",
  rankedProductsHeading: "Products sorted by phosphorus level",
  rankedProductsSubheading:
    "Products are sorted by phosphorus content (dry matter basis), from lowest to highest. No overall rating or recommendation is applied.",
  rankedProductsConfig: rankedArticleConfigs[slug],
  rankedParagraphs: {
    metricField: "phosphorusDryMatter",
    metricLabel: "Phosphorus (Dry Matter)",
    unit: "%",
    autoBucketStep: 0.1,
  },
  rankedCardFields: [
    { field: "phosphorusDryMatter", label: "Phosphorus (Dry Matter)", unit: "%", primary: true },
    { field: "sodiumDryMatter", label: "Sodium (Dry Matter)", unit: "%" },
    { field: "proteinDryMatter", label: "Protein (Dry Matter)", unit: "%" },
  ],
  sections: [
    {
      heading: "Introduction",
      paragraphs: [
        {
          text: "Phosphorus is one of the most important nutrients to watch for cats with ",
          boldText: "Chronic Kidney Disease (CKD)",
          afterText: ".",
        },
        "When kidney function declines, cats have a harder time eliminating excess phosphorus, which can accelerate disease progression.",
        {
          text: "That's why many CKD diets focus on ",
          boldText: "reducing phosphorus intake",
          afterText: ".",
        },
        {
          text: "While several well-known brands offer prescription kidney diets, there are also ",
          boldText: "non-prescription options",
          afterText:
            " with relatively low phosphorus levels - some of which may be more affordable or more appealing to picky cats.",
        },
        "This article focuses on those accessible options.",
        {
          text: "The list below is generated from The Picky Kitty database and ranks products from ",
          boldText: "lowest to highest phosphorus on a dry matter basis",
          afterText: ", so you can compare foods more accurately.",
        },
        {
          text: "Want to explore more options? Use our ",
          linkText: "filters to find all low phosphorus foods tailored to your cat",
          linkTo: "/Database",
          afterText: ".",
        },
      ],
    },
    {
      heading: "Important note",
      paragraphs: [
        {
          text: "This content is for informational purposes only and is not a substitute for veterinary advice. Always consult your veterinarian before making dietary changes, especially for cats diagnosed with CKD or other medical conditions.",
          isHighlight: true,
        },
      ],
    },
  ],
};

export default lowestPhosphorusNoPrescription;
